var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMortarboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.337 17.227c.217.97.437 2.411.307 3.925-.047.544.083 1.099.54 1.399C10.087 23.143 12.072 24 16 24s5.914-.857 6.816-1.45c.457-.3.587-.854.54-1.398-.13-1.514.09-2.954.307-3.925l-6.846 2.739a2.2 2.2 0 0 1-1.634 0z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.371 7.149a1 1 0 0 0-.742 0L2.16 12.536a.5.5 0 0 0 0 .928l4.758 1.904.12-.12a4.5 4.5 0 0 1 1.589-1.017l7.197-2.7a.5.5 0 0 1 .35.937L8.98 15.167c-.38.142-.73.348-1.037.61l7.687 3.074a1 1 0 0 0 .742 0l13.468-5.387a.5.5 0 0 0 0-.928z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.487 21.873a.995.995 0 0 1-.974 0L5 27h2z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 21,
    opacity: 0.6,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.496 20.132a.995.995 0 0 0-1 .004l-.006-1.457a4.5 4.5 0 0 1 1.332-3.214l.217-.216a4.5 4.5 0 0 1 1.589-1.018l7.197-2.7a.5.5 0 0 1 .35.937L8.98 15.167a3.5 3.5 0 0 0-1.236.792l-.217.216a3.5 3.5 0 0 0-1.036 2.5z",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortarboard);
export default __webpack_public_path__ + "static/media/Mortarboard.8bad8893f213809838ff906237a41a45.svg";
export { ForwardRef as ReactComponent };